export function playableAudioUrl(track) {
  const value = String(track?.audioURL || "").trim();
  if (!value) return "";
  try {
    const url = new URL(value, typeof window !== "undefined" ? window.location.origin : "https://vonthekeyz-staging.web.app");
    if (url.protocol !== "https:" && !(url.protocol === "http:" && ["localhost", "127.0.0.1"].includes(url.hostname))) return "";
    return url.href;
  } catch {
    return "";
  }
}

export function withPlayableAudio(track) {
  const audioURL = playableAudioUrl(track);
  return audioURL ? {...track, audioURL} : null;
}
